exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".carousel__boardMobile-module___21spJ >div:nth-child(1) {\ntop: -29px;\nbottom: initial;\nz-index: 0;\n\n}\n\n.wrapper__boardMobile-module___1Ao9L .container__boardMobile-module___1g1Wy .carousel__boardMobile-module___21spJ >div:nth-child(1) button {\nbackground-color: #0183D5;\nheight: 16px;\n/* bottom: 10px; */\n}\n\n\n.kanbanBoardContainer__boardMobile-module___90ju9 {\n    overflow-x: auto;\n}", ""]);

// Exports
exports.locals = {
	"carousel": "carousel__boardMobile-module___21spJ",
	"wrapper": "wrapper__boardMobile-module___1Ao9L",
	"container": "container__boardMobile-module___1g1Wy",
	"kanbanBoardContainer": "kanbanBoardContainer__boardMobile-module___90ju9"
};